/* Sticky ATC has been disabled via product.json settings. As a safety
   net (in case any cached or app-injected version still appears), kill
   any element matching common sticky ATC patterns. */
(function () {
  "use strict";
  var css = '\n.m-sticky-add-to-cart, .m-sticky-atc, [data-sticky-atc], .sticky-add-to-cart, .m-product__sticky-atc, .mobile-sticky-bar, [class*="sticky-add-to-cart"], [class*="sticky-atc"] {\n  display: none !important;\n  visibility: hidden !important;\n  pointer-events: none !important;\n  position: fixed !important;\n  top: -9999px !important;\n  left: -9999px !important;\n}\n';
  var style = document.createElement('style');
  style.id = 'cathaya-no-sticky-atc';
  style.textContent = css;
  if (document.head) document.head.appendChild(style);
  else document.addEventListener('DOMContentLoaded', function () { document.head.appendChild(style); });
})();
